import React from 'react';

import { useTheme } from '@components/theme';
import classNames from 'classnames/bind';
import { IFacetValue } from '@components/pages/ShopV3/model/SearchResults';
import CloseIcon from './svg/close.svg';
import styles from './Pills.module.scss';

export interface IPills {
  items: IFacetValue[];
  onClickItem: (value: IFacetValue) => void;
  onClearAll: () => void;
}

const Pills = ({ items, onClickItem, onClearAll }: IPills) => {
  const theme = useTheme();

  if (!items.length) {
    return <span>&nbsp;</span>;
  }

  return (
    <div className={classNames(theme.styles.Caption, styles.Pills)}>
      {
        items.map((item) => {
          return (
            <button key={item.id} type="button" className={styles.Pill} onClick={() => onClickItem(item)}>
              {item.value}
              <CloseIcon />
            </button>
          );
        })
      }

      <button type="button" onClick={onClearAll} className={styles.ClearAll}>Clear All</button>
    </div>
  );
};

export default Pills;
